/**
 * Action types for the Lesson Planner admin slice.
 * Mirrors preschoolEntity: one fetch action per entity + a shared UPDATE.
 */
export const FETCH_PLANNER_GRADE_GROUP_DATA = 'FETCH_PLANNER_GRADE_GROUP_DATA'
export const FETCH_PLANNER_GRADE_GROUP_DATA_SUCCESS =
  'FETCH_PLANNER_GRADE_GROUP_DATA_SUCCESS'

export const FETCH_PLANNER_SUBJECT_DATA = 'FETCH_PLANNER_SUBJECT_DATA'
export const FETCH_PLANNER_SUBJECT_DATA_SUCCESS =
  'FETCH_PLANNER_SUBJECT_DATA_SUCCESS'

export const FETCH_PLANNER_LAYOUT_DATA = 'FETCH_PLANNER_LAYOUT_DATA'
export const FETCH_PLANNER_LAYOUT_DATA_SUCCESS =
  'FETCH_PLANNER_LAYOUT_DATA_SUCCESS'

export const UPDATE_PLANNER_DATA = 'UPDATE_PLANNER_DATA'
export const UPDATE_PLANNER_DATA_SUCCESS = 'UPDATE_PLANNER_DATA_SUCCESS'
